const apiUrl = process.env.REACT_APP_API_URL;

export const webApiCarruselTextos = `${apiUrl}/front/home/carrusel_textos`;
export const webApiCarrusel = `${apiUrl}/front/home/carrusel`;
export const webApiLineaTiempo = `${apiUrl}/front/home/tiempo`;
export const webApiInstituciones = `${apiUrl}/front/home/instituciones`;
export const webApiContenido = `${apiUrl}/front/home/contenido`;
export const webApiMenu = `${apiUrl}/front/home/menu_seccion`;
export const webApiSubmenu = `${apiUrl}/front/home/submenu_seccion`;
export const webApiMenuLateral = `${apiUrl}/front/home/menu_lateral`;

export const webApiAniosRecurrencia = `${apiUrl}/api/Recurrencia/anios`;
export const webApiRecurrencia = `${apiUrl}/api/Recurrencia/recurrencia`;
export const webApiDescripcionRecurrencia = `${apiUrl}/api/Recurrencia/descripcion`;

export const webApiIntroduccionCapacitacion = `${apiUrl}/api/capacitacion/introduccion`;
export const webApiArchivosCapacitacion = `${apiUrl}/api/capacitacion/archivos`;
//urls concuros tiktok YA NO SE USAN POR QUE SE QUITO EL ROUTE PERO SE DEJA POR QUE EN EL CÓDIGO SE VALIDA
export const webApiEtapasConcurso = `${apiUrl}/front/Tiktok/etapas`;
export const webApiBasesConcurso = `${apiUrl}/front/Tiktok/bases`;
export const webApiPremiosConcurso = `${apiUrl}/front/Tiktok/premios`;
export const webApiContactoConcurso = `${apiUrl}/front/Tiktok/contacto`;
export const webApiIntroduccion = `${apiUrl}/front/Tiktok/introduccion`;
export const webApiTematica = `${apiUrl}/front/Tiktok/tematicas`;
export const webApiVideosConcurso = `${apiUrl}/front/Tiktok/videos`;
export const webApiIntegrantesConcurso = `${apiUrl}/front/Tiktok/jurado`;
//urls concuros tiktok 2025
export const webApiEtapasConcurso2025 = `${apiUrl}/front/TikTok_2025/etapas`;
export const webApiBasesConcurso2025 = `${apiUrl}/front/TikTok_2025/bases`;
export const webApiPremiosConcurso2025 = `${apiUrl}/front/TikTok_2025/premios`;
export const webApiContactoConcurso2025 = `${apiUrl}/front/TikTok_2025/contacto`;
export const webApiIntroduccion2025 = `${apiUrl}/front/TikTok_2025/introduccion`;
export const webApiTematica2025 = `${apiUrl}/front/TikTok_2025/tematicas`;
export const webApiVideosConcurso2025 = `${apiUrl}/front/TikTok_2025/videos`;
export const webApiIntegrantesConcurso2025 = `${apiUrl}/front/TikTok_2025/jurado`;



export const pathImages = process.env.REACT_APP_PATH_IMAGES;
export const pathPDF = process.env.REACT_APP_PATH_PDF;
export const nombreSitio = process.env.REACT_APP_SITIO_NOMBRE;
